/**
 * Brand colors for Fanwork
 */
export const COLORS = {
  PRIMARY: "#002ffb",
  PISTACHIO: "#b5f26d",
  MAGENTA: "#f46caa",
  LAVENDER: "#8755f5",
  SUNRISE: "#ffcd5c",
  BACKGROUND: "#f8f8f8",
  TEXT: "#323232",
} as const;

/**
 * Brand typography
 */
export const TYPOGRAPHY = {
  FONT_FAMILY: "'Zalando Sans SemiExpanded', sans-serif",
  FONT_FAMILY_HEADING: "'Zalando Sans SemiExpanded', sans-serif",
} as const;

/**
 * Brand slogan
 */
export const SLOGAN = "come together\nproduce together" as const;

/**
 * Navigation links
 */
export const NAV_LINKS = [
  { label: "About us", href: "#about-us" },
  { label: "Features", href: "#features" },
  { label: "Collabs", href: "#collabs" },
  { label: "Respect", href: "#respect" },
] as const;

/**
 * Social media links
 */
export const SOCIAL_LINKS = {
  TWITTER: "https://twitter.com/fanwork",
  INSTAGRAM: "https://instagram.com/fanwork",
  DISCORD: "https://discord.gg/fanwork",
} as const;
